import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import isEqual from 'lodash/isEqual';
import { Types, Selectors, Actions } from '@grandvisionhq/auth';
import { toast } from '@grandvisionhq/common';
import { useDispatch, useIntl, useSelector } from '@grandvisionhq/state';
import { changeFormValue } from '../../../actions.js';
import { toggleFormEditMode } from '../../actions.js';
import { useBillingAddress } from '../../hooks/use-billing-address.js';
import { toBillingAddress, mapFormStateToBillingAddressType } from '../../mappers/profile.js';
import { getBillingAddress } from '../../selectors.js';
import { ErrorAlert } from '../ErrorAlert.js';
import { LoadingData } from '../LoadingData.js';
import BillingAddress from './BillingAddress.js';

const FORM_NAME = Types.FormName.billingAddress;
const BillingAddressContainer = (props)=>{
    const dispatch = useDispatch();
    const intl = useIntl();
    const userId = useSelector(Selectors.getUserId);
    const formState = useSelector(getBillingAddress, (previousState, newState)=>isEqual(previousState, newState)
    );
    const openEditMode = React.useCallback(()=>dispatch(toggleFormEditMode({
            formName: Types.FormName.billingAddress,
            inEditMode: true
        }))
    , [
        dispatch
    ]);
    const closeEditMode = React.useCallback(()=>dispatch(toggleFormEditMode({
            formName: Types.FormName.billingAddress,
            inEditMode: false
        }))
    , [
        dispatch
    ]);
    const onCompleted = React.useCallback(({ reason , data  })=>{
        if (reason === 'QUERY') {
            var ref;
            dispatch(Actions.UserDataActions.fetchUserDataSuccess({
                [FORM_NAME]: toBillingAddress((ref = data.me) === null || ref === void 0 ? void 0 : ref.defaultBillingAddress)
            }));
        }
        if (reason === 'MUTATION') {
            var ref1;
            dispatch(Actions.UserDataActions.updateUserDataSuccess({
                formName: FORM_NAME,
                server: {
                    [FORM_NAME]: toBillingAddress((ref1 = data.updateB2CBillingAddress) === null || ref1 === void 0 ? void 0 : ref1.defaultBillingAddress)
                }
            }));
            toast.success('account.updateProfile.success');
        }
        closeEditMode();
    }, [
        dispatch,
        closeEditMode
    ]);
    const onError = React.useCallback(({ reason , error  })=>{
        if (reason === 'QUERY') {
            dispatch(Actions.UserDataActions.fetchUserDataFailed(error));
        }
        if (reason === 'MUTATION') {
            dispatch(Actions.UserDataActions.updateUserDataFailed({
                error,
                formName: FORM_NAME
            }));
            toast.failed('account.profile.settings.saveFailed');
        }
    }, [
        dispatch
    ]);
    const { billingAddressData , isFetching , isUpdating , updateBillingAddress , fetchError  } = useBillingAddress({
        onCompleted,
        onError
    });
    if (isFetching || !userId) {
        return /*#__PURE__*/ React.createElement(LoadingData, null);
    }
    if (fetchError) {
        return /*#__PURE__*/ React.createElement(ErrorAlert, {
            message: intl.getFormattedLabel('account.billingAddress.errors.network.general', {
                parseLink: true
            })
        });
    }
    const handleFormChange = (form)=>{
        dispatch(changeFormValue({
            form
        }));
    };
    const handleSaveBillingAddress = function() {
        var _ref = swcHelpers.asyncToGenerator(function*() {
            if (formState === null || formState === void 0 ? void 0 : formState.state.formValid) {
                const newData = mapFormStateToBillingAddressType(formState.state.formState);
                yield updateBillingAddress(newData, userId);
            }
        });
        return function handleSaveBillingAddress() {
            return _ref.apply(this, arguments);
        };
    }();
    const billingAddressLabels = {
        add: intl.getLabel('account.profile.billingAddress.add'),
        intro: intl.getFormattedLabel('account.profile.billingAddress.intro', {
            parseLink: true
        }),
        modalInfo: intl.getLabel('account.profile.settings.modal.info'),
        modalTitle: intl.getLabel('account.profile.billingAddress.edit'),
        noAddress: intl.getLabel('account.profile.billingAddress.noAddress'),
        note: intl.getFormattedLabel('account.profile.billingAddress.note', {
            parseHTML: true
        }),
        save: intl.getLabel('account.action.save')
    };
    return /*#__PURE__*/ React.createElement(BillingAddress, swcHelpers.extends({}, props, {
        labels: billingAddressLabels,
        isUpdating: isUpdating,
        billingAddressData: billingAddressData,
        formState: formState,
        handleFormChange: handleFormChange,
        handleSaveBillingAddress: handleSaveBillingAddress,
        toggleEditMode: openEditMode,
        closeEditMode: closeEditMode
    }));
};

export { BillingAddressContainer as default };
//# sourceMappingURL=BillingAddressContainer.js.map
